import React from 'react'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import {FancyCheckmark} from 'common/FancyCheckmark'
import styles from './SaveAsSegmentModal.scss'
import {errorMessage} from 'lib/styleguide/base.scss'
import {Segment, serializeSegment} from 'lib/api/records'
import fetchJSON from 'lib/fetchJSON'
import p from 'prop-types'
import {TrackLocation} from 'data/records'
import {currentUserHasPrivilege} from 'lib/utils'

export const SAVE_AS_SEGMENT_MODAL = 'SAVE_AS_SEGMENT_MODAL'

export class SaveAsSegmentModal extends React.PureComponent {
  static propTypes = {
    highlightSlice: p.array,
    onRequestClose: p.func
  }

  constructor (props) {
    super(props)
    this.state = {
      title: '',
      matchingScope: 'public'
    }
  }

  onInputChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  saveSegment = (e) => {
    const {troute, objectType, highlightSlice} = this.props
    const segment = new Segment(this.state)

    e && e.preventDefault()

    const indexes = highlightSlice.map(TrackLocation.closestIndex)
    const points = troute.get('rawPoints').slice(indexes[0], indexes[1])
    const segmentBase = {
      points: JSON.stringify(points), // not sure why this has to be double-encoded.
      created_from_type: objectType,
      created_from_id: troute.id
    }
    const postData = {
      segment: Object.assign(serializeSegment(segment), segmentBase)
    }

    // TODO: I should rely on the segment reducer for this, in part so the logic goes elsewhere, but we also want to update the segments list with some info on the RSP
    this.setState({savePending: true})
    fetchJSON('/segments', postData)
      .then(saveResult => this.setState({saveResult, saveError: null, savePending: false}))
      .catch(saveError => this.setState({saveError, saveResult: null, savePending: false}))
  }

  render () {
    const {onRequestClose} = this.props
    const {title, matchingScope, saveResult, saveError, savePending} = this.state

    const canCreatePrivateSegments = currentUserHasPrivilege('segments')

    return (
      <ConfirmationDialog
        title={'Save as a Segment'}
        maxWidth='600px'
        confirmText={saveResult ? 'Close' : 'Create'}
        onCancel={onRequestClose}
        showCancel={!saveResult}
        onRequestClose={onRequestClose}
        confirmPending={savePending}
        onConfirm={saveResult ? onRequestClose : this.saveSegment}>
        <div className={styles.Modal}>
          {!saveResult && <form onSubmit={this.saveSegment}>
            <p className={styles.lessMargin}>A segment will look at many rides and bring together those that include the selected track. You will be able to see the best times, race the efforts against one another, and more.</p>
            <label htmlFor='title'>Name</label>
            <input type='text' id='title' onChange={this.onInputChange} value={title} name='title' />
            <label htmlFor='matchingScope'>Which rides should we match against this segment?</label>
            <select id='matchingScope' onChange={this.onInputChange} value={matchingScope} name='matchingScope'>
              <option value='public'>Public - every ride on the site</option>
              <option value='user' disabled={!canCreatePrivateSegments}>Individual - my rides only {!canCreatePrivateSegments && ' (Premium feature)'}</option>
            </select>
          </form>}
          {saveError && <div classname={errorMessage}>
            Oops! There was an error saving that segment.  Please try again.
          </div>}
          {saveResult && <div className={styles.successMessage}>
            <FancyCheckmark />
            Your segment was saved.
          </div>}
        </div>
      </ConfirmationDialog>
    )
  }
}
